// src/pages/Admin/VotePage/hooks/useVoteActorGroups.js

import { useCallback, useState } from "react";
import { toast } from "react-toastify";

import { getGroupsList } from "../../../../services/groupServices";

export default function useVoteActorGroups() {
  const [actorGroups, setActorGroups] = useState([]);
  const [actorGroupsLoading, setActorGroupsLoading] =
    useState(false);

  const loadActorGroups = useCallback(
    async ({ force = false } = {}) => {
      if (!force && actorGroups.length > 0) {
        return actorGroups;
      }

      setActorGroupsLoading(true);

      try {
        const data = await getGroupsList();

        const normalizedGroups = Array.isArray(data)
          ? data
              .filter((group) => group?.is_active !== false)
              .map((group) => ({
                ...group,
                id: Number(group.id),
                nombreActeurs: Number(
                  group.nombreActeurs ?? 0,
                ),
              }))
              .filter((group) => Number.isFinite(group.id))
          : [];

        setActorGroups(normalizedGroups);

        return normalizedGroups;
      } catch (error) {
        console.error(
          "Erreur lors du chargement des groupes :",
          error,
        );

        setActorGroups([]);

        toast.error(
          "Impossible de charger les groupes d’acteurs.",
        );

        return [];
      } finally {
        setActorGroupsLoading(false);
      }
    },
    [actorGroups],
  );

  return {
    actorGroups,
    actorGroupsLoading,
    loadActorGroups,
  };
}